"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsLabelsOnly = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importStar(require("react"));
const TabsLabelsOnly = () => {
    const [selectedTabIndex, setSelectedTabIndex] = (0, react_2.useState)(0);
    const images = [
        'https://images.unsplash.com/photo-1490750967868-88aa4486c946?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
        'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2550&q=80',
        'https://images.unsplash.com/photo-1595433707802-6b2626ef1c91?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2600&q=80',
        'https://images.unsplash.com/photo-1560008581-09826d1de69e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=682&q=80',
    ];
    const tabLabels = ['Flower', 'Car', 'Kitten', 'Ice Cream'];
    return (react_2.default.createElement(react_1.HStack, { align: 'center', justify: 'flex-start', spacing: 10 },
        react_2.default.createElement(UiKitLite_1.UiKitLite.TabsLabelsOnly, { tabLabels: tabLabels, isNumbered: false, selectedTabIndex: selectedTabIndex, setSelectedTabIndex: setSelectedTabIndex }),
        react_2.default.createElement(react_1.Image, { boxSize: "100px", objectFit: "cover", borderRadius: 'full', src: images[selectedTabIndex], alt: tabLabels[selectedTabIndex] })));
};
exports.TabsLabelsOnly = TabsLabelsOnly;
const UiKitLite_1 = require("../UiKitLite");
